import { useMutation } from "@tanstack/react-query";
import { ContactInformationData } from "@components/forms/contact-information/types.ts";
import { ZohoService } from "@services/zoho-service.ts";
import { HouseholdInformationData } from "@components/forms/household-information/types.ts";
import { SystemConfigurationData } from "@components/forms/system-configuration/types.ts";

type LeadInformationData = HouseholdInformationData & {
  additionalInformation?: string;
  annualConsumptionKwh: number;
};

type CreateLeadRequest = {
  userId: string;
  contactInformation: ContactInformationData;
  leadInformation: LeadInformationData;
  systemConfiguration: SystemConfigurationData;
};

export const useCreateLead = () => {
  return useMutation({
    mutationFn: async ({
      userId,
      contactInformation,
      leadInformation,
      systemConfiguration,
    }: CreateLeadRequest) => {
      const service = new ZohoService();
      return await service.createLead(userId, {
        contactInformation,
        leadInformation,
        systemConfiguration,
      });
    },
  });
};
